import React from 'react'
import PropTypes from 'prop-types'
import "../styles/SmallSubscribeForm.sass"
import mysteryIcon from '../../../images/icons/mystery-icon.svg'
import spinner from '../../../images/icons/logo-icon.png'
import { SubmitButton } from '../../shared/buttons';
import { detectEnterPress } from '../../../utils/enterPress';
import { validateEmail } from '../../../utils/validateEmail';
import prose from '../../../assets/prose'
import KajabiSubscribeEmbed from "./KajabiSubscribeEmbed";

class SmallSubscribeForm extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      email: '',
      firstName: '',
      submitted: false,
      submitting: false,
      angle: 0
    }
    this.imageRef = React.createRef()

    this.submitForm = this.submitForm.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.onFormFieldChanged = this.onFormFieldChanged.bind(this);

    this.getMessage = this.getMessage.bind(this);
    this.getSubMessage = this.getSubMessage.bind(this);
  }

  onKeyUp = (e) => {
    if (detectEnterPress(e)) {
      this.submitForm();
    } 
  }

  startRotation = () => {
    this.setState({ ...this.state, submitting: true });
    this.animationFrame = requestAnimationFrame(this.rotateImage);
  };

  stopRotation = () => { 
    cancelAnimationFrame(this.animationFrame)
  }

  componentWillUnmount() {
    cancelAnimationFrame(this.animationFrame)
  }

  rotateImage = () => {
    this.setState(
      prevState => ({ angle: prevState.angle + 0.5 }), // Adjust speed here
      () => {
        this.imageRef.current.style.transform = `rotate(${this.state.angle}deg)`;
        this.animationFrame = requestAnimationFrame(this.rotateImage);
      }
    );
  };

  onFormFieldChanged = (fieldName, newValue) => {
    this.setState({
      ...this.state,
      [fieldName]: newValue
    })
  }

  submitForm = async () => {
    // This component now renders the Kajabi embed form instead of submitting here.
    // Kept as a no-op so existing key handlers/clicks don't break.
    this.setState({ ...this.state, submitted: false, submitting: false });
  }

  getMessage () {
    const { message, noMessage } = this.props;
    if (noMessage) return '';
    if (!!message) {
      return message;
    } else {
      return `Want to be notified when new content comes out?`
    }
  }

  getSubMessage () {
    const { subMessage, noMessage } = this.props;
    if (noMessage) return '';
    if (!!subMessage) {
      return subMessage;
    } else {
      return `Join ${prose.subscriberCount}+ other Software Essentialists`
    }
  }

  render () {
    const { submitted, submitting } = this.state;
    const message = this.getMessage();
    const subMessage = this.getSubMessage();

    return (
      <div className="small-subscribe-form">
        <div className="header">
            {/* <div className="icon-container">
              <img src={mysteryIcon}/>
            </div> */}
            <div className="details">
              <p className="message">
                { message }
              </p>
              <p className="sub-message">{subMessage}</p>
            </div>
        </div>
        <KajabiSubscribeEmbed buttonText="Read for free" emailPlaceholder="Your email" />
        <br/>
        <br/>
      </div>
    )
  }
}

export default SmallSubscribeForm;

SmallSubscribeForm.propTypes = {
  message: PropTypes.string,
  subMessage: PropTypes.string
}